<section [ngClass]="lang" class="error">
  <div class="container mt-auto">
    <div class="row mt-auto">
      <img class="col-md-6 col-sm-12 m-auto" src="../../../assets/images/items/error.gif">

      <article *ngIf="!codeError || !titleError || !msgError" class="col-md-6 col-sm-12 m-auto p-5">
        <h1 class="text-center">404</h1>
        <h2 *ngIf="lang=='en'" class="text-center">Page Not Found</h2>
        <h2 *ngIf="lang=='ar'" class="text-center">الصفحة غير موجودة</h2>
        <P *ngIf="lang=='en'">
          Company IT is a flamboyant and technology innovative IT service provider in Sudan which was founded and is being
          managed by very complement Sudani engineers with vast knowledge in the IT filed.
        </P>
        <P *ngIf="lang=='ar'">
          الشركة لتقانة المعلومات هي مزود خدمات تكنولوجيا المعلومات المبتكر والمبتكر في السودان والذي تأسس ويديره مهندسو
          سوداني مكملون للغاية ولديهم معرفة واسعة في مجال تكنولوجيا المعلومات.
        </P>
      </article>

      <article *ngIf="codeError && titleError && msgError" class="col-md-6 col-sm-12 m-auto p-5">
        <h1 class="text-center">{{codeError}}</h1>
        <h2 class="text-center">{{titleError}}</h2>
        <P> {{msgError}} </P>
      </article>

    </div>
  </div>
</section>
